import React from 'react';
import styled from 'styled-components';
import Unapproved from './unapproved.svg?react';
import Approved from './approved.svg?react';

const IconWrapper = styled.div`
  width: auto;
  margin-top: ${({ theme }) => theme.space.xxs};
`;

export const UnapprovedIcon = () => {
  return (
    <IconWrapper>
      <Unapproved />
    </IconWrapper>
  );
};

export const ApprovedIcon = () => {
  return (
    <IconWrapper>
      <Approved />
    </IconWrapper>
  );
};
